/* fb-cart-page.js — FreshBox redesigned cart page.
   Qty +/- and remove call /cart/change.js with the Section Rendering API so Liquid
   stays the single source of truth (subtotal, discounts, free-shipping bar re-render
   server-side). Recommendations (right column) come from /recommendations seeded off
   the last cart line; the empty cart shows best sellers. Dispatches cart:updated so the
   header bubble + side drawer stay in sync; listens to cart:refresh for the reverse. */
(function () {
  'use strict';

  var root = document.querySelector('[data-fb-cart]');
  if (!root) return;
  var SECTION_ID = root.getAttribute('data-section-id');
  var inner = root.querySelector('[data-fb-cart-inner]');

  var SECTION_REC = 'fb-rec-list';
  var recCache = { seedId: null, html: null };
  var selfMutating = false; // true while we dispatch our own cart:updated (avoids self-reload)
  var reloading = false;

  /* ---- helpers ---- */
  function money(c) { return '$ ' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function sized(url, w) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function getCart() { return window.fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function firstVariant(p) { return (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0]; }

  /* ---- recommendations (right column) — server-rendered cards via the Recommendations
     Section Rendering API so Revie review stars come through. complementary → related. ---- */
  function fetchRecHTML(seedId, intent) {
    return window.fetch('/recommendations/products?section_id=' + SECTION_REC + '&product_id=' + seedId + '&intent=' + intent + '&limit=10', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { var d = new DOMParser().parseFromString(html, 'text/html'); var box = d.querySelector('[data-fb-rec-cards]'); return box ? box.innerHTML : ''; })
      .catch(function () { return ''; });
  }
  function ensureRecHTML(seedId) {
    if (recCache.seedId === seedId) return Promise.resolve(recCache.html);
    return fetchRecHTML(seedId, 'complementary').then(function (html) {
      if (html && /fb-rec-card/.test(html)) return html;
      return fetchRecHTML(seedId, 'related');
    }).then(function (html) { recCache = { seedId: seedId, html: html || '' }; return recCache.html; });
  }
  function capCards(container, max) {
    var cards = container.querySelectorAll('.fb-rec-card');
    for (var i = max; i < cards.length; i++) cards[i].parentNode.removeChild(cards[i]);
  }
  // The empty-cart grid is server-rendered in Liquid (best sellers). Here we only fill
  // the right-column recs when the cart has items.
  function renderRecs(cart) {
    var items = (cart && cart.items) || [];
    var wrap = root.querySelector('[data-fb-cart-recs-wrap]');
    var list = root.querySelector('[data-fb-cart-recs]');
    if (!(items.length && wrap && list)) { if (wrap) wrap.hidden = true; return; }
    var seedId = items[items.length - 1].product_id;
    ensureRecHTML(seedId).then(function (html) {
      if (!html || !/fb-rec-card/.test(html)) { wrap.hidden = true; return; }
      list.innerHTML = html;
      capCards(list, 6);
      if (!list.querySelector('.fb-rec-card')) { wrap.hidden = true; return; }
      wrap.hidden = false;
    });
  }

  /* ---- DOM swap from a re-rendered section ---- */
  function applySection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshItems = doc.querySelector('[data-fb-cart-items]');
    if (!freshItems) { // cart became empty (or filled from empty) → replace whole inner
      var fi = doc.querySelector('[data-fb-cart-inner]');
      if (fi && inner) inner.innerHTML = fi.innerHTML;
      return;
    }
    [['[data-fb-cart-left]', 'html'], ['[data-fb-cart-summary-dyn]', 'html'], ['[data-fb-cart-count]', 'text']].forEach(function (pair) {
      var fresh = doc.querySelector(pair[0]);
      var cur = root.querySelector(pair[0]);
      if (!fresh || !cur) return;
      if (pair[1] === 'text') cur.textContent = fresh.textContent; else cur.innerHTML = fresh.innerHTML;
    });
  }

  // Aviso cuando un cambio no se aplicó (sin existencias, clave vencida, límite de
  // peticiones). Antes el error se tragaba y la página se quedaba como estaba.
  var noticeT = null;
  function aviso(err) {
    var msg = (err && (err.description || err.message)) || '';
    if (!msg || /^cart error$/i.test(msg) || err && err.status === 'bad_request') msg = 'No pudimos actualizar tu carrito. Intenta de nuevo.';
    var host = root.querySelector('[data-fb-cart-left]') || inner || root;
    var el = root.querySelector('[data-fb-cart-notice]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'fb-cart__notice';
      el.setAttribute('data-fb-cart-notice', '');
      el.setAttribute('role', 'status');
      host.insertBefore(el, host.firstChild);
    }
    el.textContent = msg;
    el.hidden = false;
    if (noticeT) window.clearTimeout(noticeT);
    noticeT = window.setTimeout(function () { el.hidden = true; }, 5000);
  }

  // Los cambios van en fila: dos toques rápidos mandaban dos POST en paralelo con la
  // misma clave, y Shopify recalcula la clave de la línea cuando cambia el descuento
  // (por volumen), así que el segundo fallaba en silencio. `body` es una función que
  // se evalúa al momento de mandar, sobre el DOM ya re-renderizado con las claves nuevas.
  var cola = Promise.resolve();
  function mutate(url, body) {
    cola = cola.then(function () {
      var b = typeof body === 'function' ? body() : body;
      if (!b) return; // la línea ya no está (la quitó un cambio anterior)
      b.sections = [SECTION_ID];
      b.sections_url = window.location.pathname;
      root.classList.add('is-busy');
      return window.fetch(url, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin', body: JSON.stringify(b)
      })
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }, function () { throw { status: r.status }; }); })
        .then(function (res) {
          if (res && res.sections && res.sections[SECTION_ID]) applySection(res.sections[SECTION_ID]);
          // change.js devuelve el carrito completo; add.js solo la línea agregada
          return (res && res.items) ? res : getCart();
        })
        .then(function (cart) {
          selfMutating = true;
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          selfMutating = false;
          renderRecs(cart);
        })
        .catch(function (err) { aviso(err); return reloadSection(); })
        .then(function () { root.classList.remove('is-busy'); });
    }).catch(function () {});
    return cola;
  }

  function reloadSection() {
    return window.fetch(window.location.pathname + '?section_id=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { applySection(html); return getCart(); })
      .then(function (cart) { renderRecs(cart); })
      .catch(function () {});
  }

  function lineQty(line) {
    var n = line.querySelector('[data-fb-cart-qty-n]');
    return n ? (parseInt(n.textContent, 10) || 0) : 0;
  }

  /* ---- delegated interactions (root persists across swaps) ---- */
  root.addEventListener('click', function (e) {
    var recAdd = e.target.closest ? e.target.closest('[data-fb-rec-add]') : null;
    if (recAdd) {
      var card = recAdd.closest('[data-vid]');
      var vid = card && card.getAttribute('data-vid');
      if (!vid) return;
      recAdd.classList.add('is-loading');
      mutate('/cart/add.js', { id: vid, quantity: 1 });
      return;
    }
    var line = e.target.closest ? e.target.closest('[data-fb-cart-line]') : null;
    if (!line) return;
    // La fila se reemplaza en cada re-render: al mandar se vuelve a buscar por variante
    // (data-vid) y de ahí salen la clave y la cantidad vigentes.
    var vid = line.getAttribute('data-vid'), key0 = line.getAttribute('data-key');
    function actual() {
      var rows = root.querySelectorAll('[data-fb-cart-line]');
      for (var i = 0; i < rows.length; i++) {
        if ((vid && rows[i].getAttribute('data-vid') === vid) || (!vid && rows[i].getAttribute('data-key') === key0)) return rows[i];
      }
      return null;
    }
    function cuerpo(delta) {
      return function () {
        var l = actual(); if (!l) return null;
        var q = lineQty(l) + delta;
        if (delta < 0 && q < 1) return null; // never to 0 — use Quitar
        return { id: l.getAttribute('data-key'), quantity: q };
      };
    }
    if (e.target.closest('[data-fb-cart-inc]')) mutate('/cart/change.js', cuerpo(1));
    else if (e.target.closest('[data-fb-cart-dec]')) mutate('/cart/change.js', cuerpo(-1));
    else if (e.target.closest('[data-fb-cart-remove]')) mutate('/cart/change.js', function () { var l = actual(); return l ? { id: l.getAttribute('data-key'), quantity: 0 } : null; });
  });

  /* ---- reverse sync: when the drawer/cards change the cart, re-render this page ---- */
  // selfMutating guards against reacting to our own dispatch (no loop).
  document.addEventListener('cart:updated', function () {
    if (selfMutating || reloading) return;
    reloading = true;
    reloadSection().then(function () { reloading = false; });
  });

  /* ---- initial recommendations ---- */
  getCart().then(renderRecs);
})();
